// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3s7BW","question":"Question_question__10N8m","description":"Question_description__14Tea"};